import { render } from "./brand-groups.vue?vue&type=template&id=95f70f08"
import script from "./brand-groups.vue?vue&type=script&lang=js"
export * from "./brand-groups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__